import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TradesLayer from "../../components/Trading/TradesLayer";

const TradesPage = () => {
  return (
    <MasterLayout>
      <TradesLayer pageTitle="Trades" />
    </MasterLayout>
  );
};

export default TradesPage;
